import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appModalHost]',
})
export class Drawer2Directive {
  constructor(
    public viewContainerRef: ViewContainerRef
  ) { }
}
